export default __webpack_public_path__ + "static/media/RunHorseLight_4_3.5b0e5cf6.jpg";